import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "review-nav-header" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "header-center" }
const _hoisted_5 = { class: "header-right" }

interface IProps {
  title?: string
  showBack?: boolean
  useDefaultLeft?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    title: { default: '' },
    showBack: { type: Boolean, default: true },
    useDefaultLeft: { type: Boolean, default: true }
  },
  emits: ["back"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit

function handleBack() {
  emits('back')
}

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "left", {}, () => [
        (_ctx.useDefaultLeft)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.showBack)
                ? (_openBlock(), _createBlock(_component_vkm_svg, {
                    key: 0,
                    "icon-name": "back",
                    class: "icon",
                    onClick: handleBack
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "center")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "right")
    ])
  ]))
}
}

})